<template>
  <div
    v-if="$route.meta.header == 'management'"
    id="header_management"
  >
    <div class="topWrap">
      <div class="left">
        <img
          src="@/assets/img/login/logo-management-raw.png"
          alt="智生活 Logo"
        >
      </div>
      <div class="right">
        <div
          class="funcBtn"
          @click="toPrev()"
        >
          <i
            class="icon-back"
            aria-hidden="true"
          />
          <span>上一頁</span>
        </div>
        <div
          class="funcBtn"
          @click="toHome()"
        >
          <i
            class="icon-home"
            aria-hidden="true"
          />
          <span>回首頁</span>
        </div>
        <div class="userInfo">
          {{ loginUserInfo.CommunityName&&loginUserInfo.AdminName ? loginUserInfo.CommunityName+'，'+loginUserInfo.AdminName : '' }}
        </div>
        <div
          class="funcBtn"
          @click="toLogin()"
        >
          <i
            class="icon-logout"
            aria-hidden="true"
          />
          <span>登出</span>
        </div>
        <!-- {{ nowTime }} -->
      </div>
    </div>
    <div
      class="order-food-notify-anchor"
    >
      <OrderFoodNotify />
    </div>
  </div>
  <div
    v-else
    id="header"
  >
    <div class="topWrap">
      <div class="left">
        <img
          src="@/assets/img/login/logo.png"
          alt="智生活 Logo"
        >
      </div>
      <div class="right">
        {{ nowTime }}
      </div>
    </div>
    <div class="funcWrap">
      <div
        class="left"
      >
        <!-- 多一層包裝，使 space-between 不受 v-show 影響 -->
        <div v-show="$route.name != 'home'" class="left-wrap">
          <div
            class="funcBtn"
            @click="toPrev()"
          >
            <i
              class="icon-back"
              aria-hidden="true"
            />
            <span>上一頁</span>
          </div>
          <div
            class="funcBtn"
            @click="toHome()"
          >
            <i
              class="icon-home"
              aria-hidden="true"
            />
            <span>回首頁</span>
          </div>
          <div
            class="funcBtn quickMenu"
            @mouseenter="quickMenuShow()"
            @mouseleave="quickMenuHide()"
          >
            <i
              class="icon-menu"
              aria-hidden="true"
            />
            <span>快速功能選單</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div
          v-if="$isServiceEnabled(17) || $isServiceEnabled(50)"
          class="funcBtn"
          @click="clickFuncBtn('目前訪客')"
        >
          <span class="remindMsg">{{ statesCount.visitor }}</span>
          <span class="remindMsgText">目前訪客</span>
        </div>
        <a
          v-if="$isServiceEnabled(49)"
          :href="toPage('postalList')"
        >
          <div
            class="funcBtn"
            @click="clickFuncBtn('未領取包裹')"
          >
            <span class="remindMsg">{{ statesCount.postal }}</span>
            <span class="remindMsgText">未領取包裹</span>
          </div>
        </a>
        <a
          v-if="$isServiceEnabled(49)"
          :href="toPage('postalReturnList')"
        >
          <div
            class="funcBtn"
            @click="clickFuncBtn('未退貨列表')"
          >
            <span class="remindMsg">{{ statesCount.returnPostal }}</span>
            <span class="remindMsgText">未退貨列表</span>
          </div>
        </a>
        <a
          v-if="$isServiceEnabled(48)"
          :href="toPage('collectionRecord_v2')"
        >
          <div
            class="funcBtn"
            @click="clickFuncBtn('未領取寄放物品')"
          >
            <span class="remindMsg">{{ statesCount.collectionPayment }}</span>
            <span class="remindMsgText">未領取寄放物品</span>
          </div>
        </a>
        <div class="dropdown-wrap">
          <div @click.stop="menuOpen =! menuOpen">
            {{ loginUserInfo.CommunityName&&loginUserInfo.AdminName ? loginUserInfo.CommunityName+'，'+loginUserInfo.AdminName : '' }}
            <span class="caret" />
            <i
              v-if="accountAlert && loginUserInfo.IsAuthorizationAccount"
              class="icon-caution accountAlert headerAlert"
              aria-hidden="true"
            />
          </div>
          <ul
            class="dropdown"
            :class="{'open': menuOpen, 'oneTimeAccount': loginUserInfo.IsOneTimeAccount, 'eipAccount': loginUserInfo.IsFromEip}"
          >
            <li class="dropdownTitle">
              社區管理
            </li>
            <li @click="$toPage('FeaturesSetting')">
              設定
            </li>
            <li
              v-if="loginUserInfo.IsFromEip || loginUserInfo.IsAuthorizationAccount"
              @click="goPage('accountList')"
            >
              社區帳號管理
              <i
                v-if="accountAlert"
                class="icon-caution accountAlert"
                aria-hidden="true"
              />
            </li>
            <li
              v-else-if="!loginUserInfo.IsOneTimeAccount"
              @click="$toPage('communityAdminSetting')"
            >
              使用者權限管理
            </li>
            <li
              v-if="isAttendance"
              @click="openAttendanceManagement()"
            >
              差勤管理
            </li>
            <li @click="$toPage('CommitteeMain')">
              管委服務權限設定
            </li>
            <li
              v-if="isStaffAdministrate"
              @click="openStaffAdministrate()"
            >
              工作人員管理
            </li>
            <li class="switchItem">
              <div
                class="switchdiv"
                @click="techNum = techNum == 1 ? 0 : 1"
              />
              <span>引導提示</span>
              <el-switch
                v-model="techNum"
                class="KNS-switch"
                :active-value="1"
                :inactive-value="0"
              />
            </li>
            <li class="switchItem">
              <div
                class="switchdiv"
                @click="promptNum = promptNum == 1 ? 0 : 1"
              />
              <span>文字提示</span>
              <el-switch
                v-model="promptNum"
                class="KNS-switch"
                :active-value="1"
                :inactive-value="0"
              />
            </li>
            <li class="dropdownTitle">
              個人管理
            </li>
            <li @click="selfManagement('managerQRCode')">
              管理員識別碼
            </li>
            <li @click="selfManagement('openCommunity')">
              開通新社區
            </li>
            <li @click="selfManagement('accountSetting')">
              帳號設定
            </li>
            <li
              v-if="loginUserInfo.IsAuthorizationAccount"
              @click="selfManagement('deviceManagement')"
            >
              載具管理
            </li>
            <li class="logOut">
              <div
                class="louOutBtb"
                @click="$logoutCommunity()"
              >
                <i
                  class="icon-logout"
                  aria-hidden="true"
                />
                登出
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="navbar-area fadeInDown animated"
      @mouseenter="quickMenuShow()"
      @mouseleave="quickMenuHide()"
    >
      <div class="navbar-area-inner">
        <ul>
          <li
            v-if="$isServiceEnabled(49)"
            @click="$toPage('postalDespatcher_v2')"
          >
            <div class="shortcut-button">
              <i
                class="glyphicon icon-p-des"
                aria-hidden="true"
              />
              <span>登記</span>
            </div>
          </li>
          <li
            v-if="$isServiceEnabled(49)"
            @click="$toPage('postalReceive')"
          >
            <div class="shortcut-button">
              <i
                class="glyphicon icon-p-receive"
                aria-hidden="true"
              />
              <span>領取</span>
            </div>
          </li>
          <li
            v-if="$isServiceEnabled(49)"
            @click="$toPage('postal')"
          >
            <div class="shortcut-button">
              <i
                class="glyphicon icon-package"
                aria-hidden="true"
              />
              <span>郵務管理</span>
            </div>
          </li>
          <li
            v-if="$isServiceEnabled(48)"
            @click="$toPage('collectionPayment_v2')"
          >
            <div class="shortcut-button">
              <i
                class="glyphicon icon-collectionP"
                aria-hidden="true"
              />
              <span>寄放物品</span>
            </div>
          </li>
          <li
            v-if="$isServiceEnabled(17)"
            @click="$router.push({ name: 'PlusGuestReservation' , params: { guestId: 'List'}})"
          >
            <div class="shortcut-button">
              <i
                class="glyphicon icon-identification"
                aria-hidden="true"
              />
              <span>訪客管理</span>
            </div>
          </li>
          <li
            v-if="$isServiceEnabled(50)"
            @click="$toPage('CommunityGuestControl')"
          >
            <div class="shortcut-button">
              <i
                class="glyphicon icon-identification"
                aria-hidden="true"
              />
              <span>訪客登記</span>
            </div>
          </li>
          <li v-if="$isServiceEnabled(50)">
            <div
              class="shortcut-button"
              @click="$emit('dialogVisitorFastLeave')"
            >
              <i
                class="glyphicon icon-identification-exit"
                aria-hidden="true"
              />
              <span>訪客離開</span>
            </div>
          </li>
          <li>
            <div
              class="shortcut-button"
              @click="$emit('faseActive')"
            >
              <i
                class="glyphicon icon-open-service"
                aria-hidden="true"
              />
              <span>住戶開通</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <NewMarquee
      v-if="$route.name === 'home'"
      id="marquee"
      @visibility-change="marqueeVisible = $event"
    />
    <div
      class="order-food-notify-anchor"
      :class="{ 'order-food-notify-anchor--with-marquee': marqueeVisible }"
    >
      <OrderFoodNotify />
    </div>
  </div>
</template>
<script>
import { CommunityMainServiceType, communityMainServiceMap, communityMainFixedServiceMap } from '@/js/utils/communityMainService'
import { apiCore } from '@/api/core.js'
import { housekeeperAPI } from '@/api/HousekeeperAPI.js'
import NewMarquee from '@/views/Main/components/NewMarquee.vue'
import OrderFoodNotify from '@/components/Notify/OrderFoodNotify'

export default {
  components: {
    NewMarquee,
    OrderFoodNotify
  },
  data () {
    return {
      nowTimer: null,
      nowTime: '',
      loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo')) || {},
      statesCount: {
        visitor: 0,
        postal: 0,
        returnPostal: 0,
        collectionPayment: 0
      },
      menuOpen: false,
      techNum: parseInt(localStorage.getItem('techNum')),
      promptNum: parseInt(localStorage.getItem('promptNum')),
      visitorDialog: true,
      accountAlert: false,
      crossCommunityClockAuth: null, // 開啟新版跨案場打卡
      marqueeVisible: false
    }
  },
  computed: {
    isNewVisitor () {
      return this.$store.getters.isServiceEnabled(17) // 新訪客功能開關
    },
    isOldVisitor () {
      return this.$store.getters.isServiceEnabled(50) // 舊訪客功能開關
    },
    isPostal () {
      return this.$store.getters.isServiceEnabled(49) // 郵務功能開關
    },
    isCollection () {
      return this.$store.getters.isServiceEnabled(48) // 寄放功能開關
    },
    isPatrol () {
      return this.$isServiceEnabled(9) // 巡邏功能開關
    },
    isAttendance () {
      return this.$isServiceEnabled(4) // 差勤功能開關
    },
    isStaffAdministrate () { // 判斷下拉選單是否顯示「工作人員管理」
      // 有開巡邏，一定要顯示「工作人員管理」
      if (this.isPatrol) {
        return true
      }
      if (this.isAttendance) {
        // 沒開巡邏、有開差勤，如果開跨案場就不顯示「工作人員管理」
        return !this.crossCommunityClockAuth
      }
      return false
    }
  },
  watch: {
    '$route.name' (name) {
      if (name !== 'home') this.marqueeVisible = false
    },
    '$store.state.localStorage' (newVal) {
      // 更新 loginUserInfo （社區名稱、姓名）至畫面與 infobip
      this.loginUserInfo = newVal.loginUserInfo || {}
    },
    techNum (newVal, oldVal) {
      localStorage.setItem('techNum', newVal)
      this.promptNum = newVal
    },
    promptNum (newVal, oldVal) {
      this.promptNum = (this.techNum === 1) ? newVal : 0
      localStorage.setItem('promptNum', newVal)
    },
    menuOpen (newVal, oldVal) {
      const vobj = this
      const menuDom = document.querySelector('.dropdown')
      if (newVal) {
        if (menuDom) {
          menuDom.addEventListener('click', stopPage)
          document.body.addEventListener('click', closeMenu)
          this.updateDropdownHeight()
        }
      } else {
        if (menuDom) menuDom.removeEventListener('click', stopPage)
        document.body.removeEventListener('click', closeMenu)
      }
      function stopPage (eve) {
        eve.stopPropagation()
      }
      function closeMenu () {
        vobj.menuOpen = false
      }
    }
  },
  async mounted () {
    // 同步 function
    this.getNowTime() // 時間（年月日、星期、時分秒）
    this.nowTimer = setInterval(() => {
      this.getNowTime()
    }, 1000)

    // 無序 API
    this.getAccountAlert() // 姓名右上方警示驚嘆號（有其他管理員太久沒登入）

    // 監聽
    window.addEventListener('resize', this.updateDropdownHeight)

    // 有序 API
    await this.getServiceArray() // 先確認該社區開了哪些服務
    this.getNavbarBadgeCount() // 後取得 Badge 等相關資料
    this.getCrossCommunityClock() // 確認差勤跨案場與否
    if (this.$store.getters.isServiceEnabled(32)) {
      this._getSmartLockerTutorialUrl() // 若有智慧櫃，則索取其教學連結
    }
  },
  beforeDestroy () {
    clearInterval(this.nowTimer)
  },
  methods: {
    getUncollectedCollectionPaymentCount () {
      // 取得未領取寄放物品數量
      housekeeperAPI.getUncollectedCollectionPaymentCount().then(res => {
        this.statesCount.collectionPayment = res.data.Data.UncollectedCount
      }).catch(err => {
        console.error('Error fetching uncollected collection payment count:', err)
      })
    },
    getOldGuestArrivedCount () {
      // 取得舊訪客抵達數量
      housekeeperAPI.getOldGuestArrivedCount().then(res => {
        this.statesCount.visitor = res.data.Data.ArrivedGuestCount
      }).catch(err => {
        // 處理錯誤
      })
    },
    getUnreturnedPostalCount () {
      // 取得未退貨郵務數量
      housekeeperAPI.getUnreturnedPostalCount().then(res => {
        this.statesCount.returnPostal = res.data.Data.ReturnPostalCount
      }).catch(err => {
        // 處理錯誤
      })
    },
    getUnclaimedPostalCount () {
      // 取得未領取包裹數量
      housekeeperAPI.getUnclaimedPostalCount().then(res => {
        this.statesCount.postal = res.data.Data.UnclaimedPostalCount
      }).catch(err => {
        // 處理錯誤
      })
    },
    updateDropdownHeight () {
      this.$nextTick(() => {
        const dropdown = document.getElementsByClassName('dropdown open')[0]
        // 更新下拉選單高度
        if (dropdown) {
          dropdown.style.height = `calc( 100vh - ${document.getElementById('app-header').offsetHeight}px)`
        }
      })
    },
    toPage (url) {
      return `${window.location.origin}/community/${url}.aspx`
    },
    getNowTime () {
      const padDate = val => val < 10 ? '0' + val : val
      const now = new Date()
      const year = now.getFullYear()
      const month = padDate(now.getMonth() + 1)
      const date = padDate(now.getDate())
      const day = ['日', '一', '二', '三', '四', '五', '六'][now.getDay()]
      const hours = padDate(now.getHours())
      const minutes = padDate(now.getMinutes())
      const seconds = padDate(now.getSeconds())
      this.nowTime = `${year}年${month}月${date}日 星期${day} ${hours}:${minutes}:${seconds}`
    },
    getLoginUserInfo () {
      if (localStorage.getItem('loginUserInfo')) {
        this.loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo')) || {}
        this.$infobipSetUser(this.loginUserInfo)
      } else {
        this.$infobipSetUser()
      }
    },
    toPrev () {
      // eslint-disable-next-line eqeqeq
      if (this.$route.meta.prev && this.$route.meta.prev == 'goHome') {
        this.$toMainPage()
      } else if (this.$route.meta.prev && this.$route.meta.prev.indexOf('mainPage/') > -1) {
        const destination = this.$route.meta.prev.replace('mainPage/', '')
        this.$toPage(destination)
      // eslint-disable-next-line eqeqeq
      } else if (this.$route.meta.prev && this.$route.meta.prev == 'other') {
        this.$router.push(previousPage)
      } else {
        this.$router.push({ name: this.$route.meta.prev })
      }
    },
    toHome () {
      sessionStorage.setItem('serviceCardIndex', 0)
      this.$toMainPage()
    },
    toLogin () {
      this.$logoutCommunity()
    },
    async getNavbarBadgeCount () {
      // badge 數值、較即時更新的資料，route change 時也會被呼叫、藉由流程增加減少數值時也會呼叫

      // 如果是管理費 / 智慧建築首頁的 Navbar，因沒有 badge、故不需要更新 badge 數值
      if (this.$route.meta.header === 'management') return

      // 訪客
      this.getGuestArrivedCount ()
      // 郵務
      this.getUnclaimedPostalCount()
      // 郵務 - 退貨
      this.getUnreturnedPostalCount()
      // 未領取寄放物品
      this.getUncollectedCollectionPaymentCount()
    },
    clickFuncBtn (title) {
      this.$sendGAEvent('Badge使用數', {
        value: `click_${title}`
      })
      switch (title) {
      case '目前訪客':
        this.openGuestDialog()
        break
      case '未領取包裹':
        this.$toPage('postalList')
        break
      case '未退貨列表':
        this.$toPage('postalReturnList')
        break
      case '未領取寄放物品':
        this.$toPage('collectionRecord_v2')
        break
      default:
        break
      }
    },
    openGuestDialog () {
      if (this.isNewVisitor) {
        // 新訪客
        this.$emit('openGuestDialog')
      } else if (this.isOldVisitor) {
        // 舊訪客
        this.$emit('dialogVisitor')
      }
    },
    getGuestArrivedCount () {
      if (this.isNewVisitor) {
        // 新訪客
        this.getNewGuestArrivedCount()
      } else if (this.isOldVisitor) {
        // 舊訪客
        this.getOldGuestArrivedCount()
      }
    },
    async getNewGuestArrivedCount () {
      apiGuest.GuestDialog.GetGuestArrivedTotal().then((res) => {
        this.statesCount.visitor = res.data
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    async getCrossCommunityClock () {
      // 確認差勤跨案場與否
      try {
        const isAttendance = this.$isServiceEnabled(4)
        if (isAttendance) {
          const res = await apiAttendanceManagement.GetCommunityClockAuth()
          this.crossCommunityClockAuth = !!res?.data?.Data?.IsOpenCrossCommunityClock
        }
      } catch (err) {
        console.log('錯誤訊息：', err.response)
      }
    },
    // click[差勤管理]
    openAttendanceManagement () {
      if (this.crossCommunityClockAuth) { this.goPage('AttendanceManagement') } else { this.$toPage('serviceManager') }
    },
    // click[工作人員管理]
    openStaffAdministrate () {
      if (this.$isServiceEnabled(4) && this.crossCommunityClockAuth) {
        window.location.href = `${window.location.origin}/community/patrolAdministrate.aspx`
        localStorage.setItem('PatrolPersonnelManagement', true)
      } else {
        this.$toPage('staffAdministrate')
      }
    },
    quickMenuShow () {
      document.querySelector('.navbar-area').style.display = 'block'
    },
    quickMenuHide () {
      document.querySelector('.navbar-area').style.display = 'none'
    },
    goPage (page) {
      this.$router.push({ name: page })
      this.menuOpen = false
    },
    getAccountAlert () {
      // 如果是管理費 / 智慧建築首頁的 Navbar，因沒有姓名右上角驚嘆號、故不需要更新是否顯示
      if (this.$route.meta.header === 'management') return

      const loginUserInfoJSON = localStorage.getItem('loginUserInfo')
      const loginUserInfo = loginUserInfoJSON ? JSON.parse(loginUserInfoJSON) : {}
      if (loginUserInfo.IsFromEip || !loginUserInfo.IsAdmin) return
      const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationAccounts/PassiveUse/Alert`
      axios(url, {
        method: 'GET',
        headers: {
          kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
        }
      }).then(res => {
        this.accountAlert = res.data.Data.Alert
      }).catch(err => {
        console.log(err.response)
      })
    },
    selfManagement (activity) {
      if (!this.loginUserInfo.IsAuthorizationAccount) {
        this.$confirm('此功能限社區管理人員帳號使用，請重新註冊新制「社區管理人員帳號」', '提示', {
          confirmButtonText: '前往註冊',
          cancelButtonText: '取消',
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          this.$router.push({ name: 'LoginMainRegister' })
        }).catch(e => {})
      } else {
        switch (activity) {
        case 'openCommunity':
          this.$emit('showOpenCodeDialog')
          break
        case 'accountSetting':
          this.goPage('changeInfo')
          break
        case 'deviceManagement':
          this.goPage('DeviceManagement')
          break
        case 'managerQRCode':
          this.$emit('managerQRCode')
          break
        }
      }
    },
    async getServiceArray () {
      // 取得各服務的資料，主要取用開關的資訊
      // 在此處取得資訊會較即時，在有該元件的頁面（多數）重新整理即會更新資料
      // 最常取用此資料的元件為此元件
      // 避免只有在首頁時才會更新資料的情形
      try {
        const res = await apiCore.getCommunityMainService()
        const beServiceList = res.data.Data.CommunityMainServices
        const feServiceList = []
        beServiceList.forEach(el => {
          let feInfo = {}
          switch (el.CommunityMainServiceType) {
          case CommunityMainServiceType.Plugin:
            // 取得前端一般服務資訊
            feInfo = communityMainServiceMap.get(el.Id)
            break
          case CommunityMainServiceType.Fixed:
            // 取得前端常開服務資訊
            feInfo = communityMainFixedServiceMap.get(el.Id)
            break
          default:
            break
          }
          if (feInfo) {
            // 前端可 mapping 到的功能才會呈現，否則會缺漏名稱、icon、路由等資訊
            feServiceList.push({
              ...el,
              ...feInfo
            })
          }
          if (el.Id === 50) {
            // 舊版訪客需增加訪客離開
            const oldVisitorFeInfo = communityMainServiceMap.get(-1) || {}
            feServiceList.push({
              ...el,
              ...oldVisitorFeInfo,
              Id: -1,
              Display: '訪客離開'
            })
          }
        })
        // 含純功能
        localStorage.setItem('communityMainService', JSON.stringify(feServiceList))
      } catch (error) {
        console.error(error)
      }
    },
    async _getSmartLockerTutorialUrl () {
      try {
        const { data } = await housekeeperAPI.getSmartLockerTutorialUrl()
        const smartLockerTutorialLink = data.Data.TutorialUrl
        this.$store.commit('upsertExternalLinks', { smartLockerTutorialLink })
      } catch (error) {
        console.error(error)
        const smartLockerTutorialLink = ''
        this.$store.commit('upsertExternalLinks', { smartLockerTutorialLink })
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#header
  position: relative
  box-shadow: 0px 3px 13px 4px #bbb
  .topWrap
    display: flex
    justify-content: space-between
    align-items: center
    background-color: $mainColor
    padding: 10px 10px 10px 20px
    color: $white
    .left
      img
        height: 40px
    .right
      opacity: 0.9
      font-size: 22px
  .funcWrap
    // 調整為 flex 屬性，避免父子層高度計算有部分落差的情形
    display: flex
    justify-content: space-between
    flex-wrap: wrap // 因應使用者放大到 125% 的情境，若一行不夠放就拆成兩行
    align-items: center
    background-color: $white
    padding: 6px 0px 3px
    color: $mainFontColor
    font-size: 20px
    position: relative
    width: 100%
    .left
      flex: 1 0 auto
      box-sizing: border-box
      min-height: 40px
      line-height: 40px
      div
        float: left
        box-sizing: border-box
      .funcBtn
        cursor: pointer
        font-weight: bold
        margin: 0 15px
        i
          margin-right: 5px
      .quickMenu
        &:hover
          span
            text-decoration: underline
        &::before
          content: ' '
          height: 100%
          display: block
          position: absolute
          width: 150px
          height: 40px
          top: 0
    .right
      flex: 1 0 auto
      display: flex
      justify-content: flex-end // 右側的元素維持靠右，盡量維持相近的使用習慣
      box-sizing: border-box
      div
        float: left
      .funcBtn
        cursor: pointer
        font-weight: bold
        line-height: 40px
        margin-right: 24px
      .remindMsg
        display: inline-block
        border-radius: 20px
        font-size: 20px
        color: $white
        background: $warnColor
        border: 1px solid $warnColor
        text-shadow: none
        font-weight: 700
        line-height: 30px
        min-width: 28px
        height: 30px
        padding: 0 1px
        text-align: center
        vertical-align: 2px
      .remindMsgText
        margin-left: 5px
        color: $mainFontColor
        &:hover
          text-decoration: underline
      .dropdown-wrap
        font-weight: bold
        position: relative
        display: block
        padding: 0 24px 0 0px
        line-height: 40px
        cursor: pointer
        .caret
          display: inline-block
          width: 0
          height: 0
          margin-left: 2px
          vertical-align: middle
          border-top: 4px dashed
          border-right: 4px solid transparent
          border-left: 4px solid transparent
        .dropdown
          z-index: 98
          position: absolute
          display: none
          list-style: none
          top: 43px
          right: 0
          min-width: 200px
          background-color: $white
          box-shadow: -1px 2px 2px rgba(102, 102, 102, 0.2)
          overflow: hidden
          transition: all 0.2s linear
          opacity: 0
          li
            color: #2f2f2f
            font-family: Arial, 微軟正黑體, 新細明體, sans-serif
            font-size: 15px
            font-weight: normal
            line-height: 1.42857143
            white-space: nowrap
            padding: 10px 25px
            font-size: 15px
            text-decoration: none
            &:hover
              background-color: #ebebeb
            ::v-deep .el-switch
              +KNSSwitch
            ::v-deep .el-switch.is-checked
              +KNSSwitchIsChecked
            &.dropdownTitle
              font-size: 16px
              cursor: auto
              padding: 12px 12px 2px 16px
              border-top: 1px solid #efefef
              font-weight: bold
              &:hover
              background-color: $white
            &.switchItem
              display: flex
              position: relative
              .switchdiv
                position: absolute
                top: 0
                left: 0
                height: 100%
                width: 200px
              span
                margin-right: 10px
          .logOut
            border-top: 1px solid #efefef
            text-align: right
            padding: 0
            height: 57px
            .louOutBtb
              float: right
              color: #fff !important
              background-color: $mainColor
              line-height: initial
              display: inline-block
              font-weight: 400
              padding: 6px 12px
              font-size: 17px
              border-radius: 2px
              margin: 10px
              i
                margin-right: 3px
                vertical-align: text-bottom
              &:hover,&:active
                color: #fff !important
                background-color: $mainColorDark
                border-color: $mainColorDark
                outline: none
        .dropdown.open
          display: block
          max-height: 590px
          overflow: auto
          border-top: $borderDark3 1px solid
          opacity: 1
        .accountAlert
          margin-left: 4px
          color: $warnColor
          font-size: 16px
          vertical-align: text-top
          &.headerAlert
            position: absolute
            right: 12px
  .navbar-area
    +quickMenuEffect()
    text-align: center
    padding: 15px
    background: #383838
    border-bottom: none
    border-top: 1px solid #cdcdcd
    margin-top: -1px
    position: absolute
    left: 0px
    width: 100%
    z-index: 19
    display: none
    box-sizing: border-box
    .navbar-area-inner
      overflow: hidden
      width: 100%
      height: auto
      ul
        li
          display: inline-block
          padding: 0 5px
          .shortcut-button
            width: 105px
            text-decoration: none
            float: left
            text-align: center
            padding: 10px
            border-radius: 4px
            border: 1px solid transparent
            cursor: pointer
            &:hover
              border: 1px solid $mainColor
              i,span
                color: $mainColor
            i
              color: #eee
              font-size: 38px !important
              height: 64px
              width: 64px
              transition: color
              transition-duration: 0.1s
              margin-right: 0
            span
              display: block
              line-height: 1
              overflow: hidden
              white-space: nowrap
              width: 100%
              text-overflow: ellipsis
              font-size: 20px
              color: #eee
              margin-top: 16px
              transition: color
              transition-duration: 0.1s
              text-align: center
              font-weight: normal
</style>
<style lang="sass" scoped>
#header_management
  position: relative
  box-shadow: 0px 3px 8px 4px $bgDark1
  .topWrap
    display: flex
    justify-content: space-between
    align-items: center
    background-color: $white
    padding: 15px 20px
    .left
      img
        height: 42px
    .right
      display: flex
      justify-content: space-between
      align-items: center
      font-size: map-get($fontSize,large)
      .funcBtn
        color: $mainColor
        margin-right: 15px
        cursor: pointer
      .userInfo
        margin: 0 20px
#marquee
  position: absolute
.order-food-notify-anchor
  position: absolute
  top: 100%
  left: 0
  right: 0
  &--with-marquee
    top: calc(100% + 46px)
</style>
